import { updateAndOrQueue } from "shared/middleware/waitForId/waitForIdSlice";

//updating
export const updateItemThunkAction = (payload) => (dispatch, getState) => {
  const { id } = payload;
  const effect = {
    url: "items",
    id,
    json: payload.attributes,
    method: "PATCH",
  };
  const updateAction = {
    type: "itemLists/updateItem",
    payload,
    meta: {
      offline: {
        effect: effect,
        commit: { type: "itemLists/updateItem.commit" },
      },
    },
  };
  updateAndOrQueue({
    dependsOn: "itemLists/saveNewTask.commit",
    id,
    effect,
    updateAction,
    dispatch,
  });
};

export function updateItemCaseLogic(state, action) {
  state.needsReload = updateItemState(state, action.payload);
  state.status = "pending";
}

function updateItemState(state, payload) {
  const { attributes, method, isDueItem } = {
    method: { type: "openItem" },
    ...payload,
  };
  switch (method.type) {
    case "index":
      return updateItemStateByIndex({ state, attributes, method, isDueItem });
    case "openItem":
      return updateItemStateWithOpenItem({ state, attributes, isDueItem });
  }
}

function updateItemStateWithOpenItem({ state, attributes, isDueItem }) {
  const openItem = state.openItem;
  const updatedItem = { ...openItem.details, ...attributes };
  const nr = needsReload(openItem.details, attributes);
  if (attributes.done) {
    updatedItem.isJustCompleted = true;
  } else if (attributes.done === false) {
    updatedItem.isJustMarkedUndone = true;
  }
  if (nr) {
    updatedItem.isPending = true;
  }
  let items;
  if (state.openItem.isDone) {
    items = state.doneItems;
  } else {
    items = isDueItem ? state.dueItems : state.items;
  }
  items.splice(openItem.index, 1, updatedItem);
  return nr;
}

function updateItemStateByIndex({ state, attributes, method, isDueItem }) {
  const items = isDueItem ? state.dueItems : state.items;
  const oldItem = items[method.index];
  items[method.index] = { ...oldItem, ...attributes };
  return false;
}

function needsReload(oldItem, attrs) {
  return (
    oldItem.type === "calendar_note" ||
    oldItem.type === "continuing_calendar_note" ||
    attrs.type === "calendar_note" ||
    !!attrs.day
  );
}

export const completeItemThunkAction = (payload) => (dispatch, getState) => {
  const { preventPatch, id } = payload;
  const action = {
    type: "itemLists/completeItem",
    payload,
  };
  if (!preventPatch) {
    const meta = {
      offline: {
        effect: {
          url: "items",
          json: { done: true, done_time: new Date().toString() },
          id,
          method: "PATCH",
        },
      },
    };
    action.meta = meta;
  }
  dispatch(action);
};

export const markItemUndoneThunkAction = (payload) => (dispatch, getState) => {
  const { preventPatch, id } = payload;
  const action = {
    type: "itemLists/markItemUndone",
    payload,
  };
  if (!preventPatch) {
    const meta = {
      offline: {
        effect: {
          url: "items",
          json: { done: false },
          id,
          method: "PATCH",
        },
      },
    };
    action.meta = meta;
  }
  dispatch(action);
};

export const addChecklistThunkAction = (payload) => (dispatch, getState) => {
  const openItem = getState().itemLists.openItem;
  const effect = {
    url: "checklists",
    json: { item_id: openItem.details.id },
    method: "POST",
  };
  dispatch({
    type: "itemLists/addChecklist",
    payload: { index: openItem.index },
    meta: {
      offline: {
        effect,
        commit: {
          type: "planItem/addChecklist.commit",
        },
      },
    },
  });
};

export const removeChecklistThunkAction = (payload) => (dispatch, getState) => {
  const openItem = getState().itemLists.openItem;
  const effect = {
    url: "checklists",
    id: openItem.details.id,
    method: "DELETE",
  };
  dispatch({
    type: "itemLists/removeChecklist",
    payload: { index: openItem.index },
    meta: {
      offline: {
        effect,
        commit: {
          type: "planItem/removeChecklist.commit",
        },
      },
    },
  });
};
